import * as React from 'react';
import c from 'classnames';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  DynamicMediaItem,
  LinkList,
  ListCard,
} from '../../../../components';
import { TaxonomyTheme } from '../../custom';
import { DEFAULT_LANGUAGE, LINKLIST_TAXONOMY_THEME_TEASER_MAX_LENGTH } from '../../../../config/constants';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTeaser: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const langcode = theme.langcode[0].value;

  const { children = [] } = theme;
  const classes = c('TaxonomyThemeTeaser', 'd-flex', 'h-100');

  return (
    <div className={classes}>
      <ListCard
        title={theme.name[0].value}
        link={theme.paths[DEFAULT_LANGUAGE]}
        image={(
          <DynamicMediaItem media={theme.field_media_item[0]} imageAspectRatio="16_9" />
        )}
        items={children.length > 0 && (
          <LinkList
            maxLength={LINKLIST_TAXONOMY_THEME_TEASER_MAX_LENGTH as number}
          >
            {children.map((child) => (
              <LinkList.TertiaryItem
                key={child.uuid[0].value}
                title={child.name[0].value}
                link={child.paths[langcode]}
              />
            ))}
          </LinkList>
        )}
      />
    </div>
  );
};

export default TaxonomyThemeTeaser;
